import { setLocale } from 'yup';

export const setValidationLocale = () => {
  setLocale({
    // general mixed type messages
    mixed: {
      default: 'Ongeldige waarde',
      required: 'Dit veld is verplicht'
    },
    // string-specific messages (Dutch)
    string: {
      min: ({ min, path }) => `${path} moet minimaal ${min} karakters zijn`,
      max: ({ max, path }) => `${path} mag maximaal ${max} karakters zijn`,
      email: 'Ongeldig e-mailadres',
      length: ({ length }) => `Moet precies ${length} karakters lang zijn`,
      matches: 'Ongeldig formaat'
    },
    // number-specific messages (Dutch)
    number: {
      min: ({ min }) => `Moet minimaal ${min} zijn`,
      max: ({ max }) => `Mag maximaal ${max} zijn`
    },
    // date-specific messages (Dutch)
    date: {
      min: ({ min }) => `Datum moet na ${min} zijn`,
      max: ({ max }) => `Datum moet voor ${max} zijn`
    }
  });
};
